import React from 'react'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import PropTypes from 'prop-types'
import PlacesAutocomplete from 'react-places-autocomplete'
import queryString from 'query-string'

import { withStyles, TextField, MenuItem, Paper, Button, InputAdornment, Hidden } from '@material-ui/core'
import { KeyboardBackspace, Search } from '@material-ui/icons'

import * as actions from '../actions'
import * as types from '../constants'
import * as utils from '../utils'

const styles = theme => ({
  demo: {
    height: 400,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    maxWidth: '100%',
    margin: 0,
  },
  searchBox: {
    maxWidth: '100%',
    margin: '0 auto',
    height: '50px',
    color: theme.palette.text.secondary,
    [theme.breakpoints.down('650')]: {
      maxWidth: '95%',
    },
    [theme.breakpoints.down('600')]: {
      height: '36px',
      maxWidth: '100%',
    },
    [theme.breakpoints.down('400')]: {
      maxWidth: '100%',
      height: '36px',
    },
  },
  control: {
    padding: theme.spacing.unit * 2,
  },
  bannerTitle: {
    fontSize: 25,
    fontWeight: 400,
    lineHeight: '1.36',
    textAlign: 'center',
    color: '#ffffff',
    padding: '25px 40px',
  },
  searchParent: {
    '& inputDiv': {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipses',
      maxWidth: 'calc(100% - 108px)',
    },
  },
  searchBtn: {
    minHeight: '50px',
    lineHeight: '50px',
    width: '108px',
    borderRadius: '0 4px 4px 0',
    backgroundColor: '#00bcb5',
    margin: 0,
    fontSize: 16,
    fontWeight: 500,
    textAlign: 'center',
    color: 'rgba(255, 255, 255, 0.8)',
    padding: '0 20px',
    '&:hover': {
      backgroundColor: '#00bcb5',
      color: '#ffffff',
    },
    '&:focus': {
      backgroundColor: '#00bcb5',
    },
    [theme.breakpoints.down('xs')]: {
      width: '36px',
      padding: '0',
      minWidth: '36px',
      minHeight: '36px',
      lineHeight: '45px',
    },
  },
  headerSearchBtn: {
    minHeight: '44px',
    minWidth: '44px',
    width: '44px',
    padding: '0',
    lineHeight: 0,
    [theme.breakpoints.down('sm')]: {
      minHeight: '36px',
    },
    '& svg': {
      height: '44px',
    },
  },
  searchFilter: {
    color: '#ffffff',
    fontSize: 13,
    textAlign: 'center',
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 25,
    cursor: 'pointer',
  },
  autocompleteDropdownContainer: {
    maxWidth: 'calc(100% - 110px)',
    minWidth: 'calc(100% - 110px)',
    margin: '2px 0px 0px',
    position: 'relative',
    zIndex: 1,
    borderRadius: '4px',
    overflow: 'hidden',
    boxShadow: '0 2px 12px 2px rgba(0, 0, 0, 0.09)',
    [theme.breakpoints.down('xs')]: {
      maxWidth: 'calc(100% - 37px)',
      minWidth: 'calc(100% - 37px)',
    },
    '&:hover': {
      backgroundColor: '#1dbbb0',
    },
    '& li': {
      margin: '0',
      padding: '3px',
      height: '40px',
    },
    '& li > span': {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      margin: '0px',
      padding: '0 21px',
      fontSize: '14px',
      color: '#231f20',
      fontFamily: 'Rubik',
      fontWeight: '500',
    },
  },
  suggestionSection: {
    height: '177px',
    backgroundColor: '#ffd200',
    boxShadow: '0 0 8px 0 rgba(0, 0, 0, 0.04)',
    padding: '40px 20px 20px',
    transition: 'all 0.9s ease-in-out',
    overflow: 'hidden',
    zIndex: -1,
  },
  transit: {
    minHeight: 0,
    height: 0,
    padding: 0,
  },
  suggestionListItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '& > span': {
      opacity: '0.7',
      fontSize: '15px',
      fontWeight: '500',
      lineHeight: '1.33',
      color: '#000000',
    },
    '& > p': {
      opacity: '0.5',
      fontSize: '15px',
      lineHeight: '1.33',
      color: '#000000',
    },
  },
  searchInputWrapper: {
    '& > input': {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      [theme.breakpoints.down('xs')]: {
        fontSize: '14px',
      },
    },
  },
  suggestionitems: {
    backgroundColor: '#ffffff',
    padding: '0',
  },
  suggestionLi: {
    width: '100%',
    height: '40px',
    display: 'block',
    fontSize: '14px',
    fontWeight: '500',
    lineHeight: '40px',
    padding: '0px 13px 0px 12px',
    margin: '0',
    borderRadius: '4px',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    '&:hover': {
      backgroundColor: 'rgba(29, 187, 176, 0.13)',
      color: '#00bcb5',
    },
  },
  locationSearchInput: {
    width: '100%',
    '& input': {
      fontSize: '16px',
      fontWeight: '500',
      color: '#231f20',
      paddingRight: '10px',
      [theme.breakpoints.down('xs')]: {
        fontSize: '14px',
        padding: '0 10px',
      },
    },
  },
  menuSearchBox: {
    height: '44px',
    backgroundColor: 'rgba(0, 0, 0, 0.06)',
    width: '460px',
    boxShadow: 'none',
    marginLeft: '20px',
    '& locationSearchInput': {
      '& InputAdornment': {
        display: 'none',
      },
    },
    '& input': {
      color: '#2d3447',
      fontWeight: '400',
      paddingLeft: '15px',
    },
    [theme.breakpoints.down('1040')]: {
      width: '375px',
      marginTop: '0px',
    },
    [theme.breakpoints.down('650')]: {
      width: '325px',
    },
    [theme.breakpoints.down('sm')]: {
      height: '36px',
      '& button': {
        '& svg': {
          height: '36px',
        },
      },
    },
  },
  searchAsHeader: {
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: 1,
    height: '48px',
    width: '100%',
    maxWidth: '100%',
    borderRadius: 0,
    lineHeight: 2.4,
    '& button': {
      borderRadius: 0,
      minHeight: '48px',
      minWidth: '48px',
      lineHeight: 3.6,
      '& > span': {
        '& span': {
          lineHeight: '48px',
          display: 'flex',
        },
      },
    },
  },
  inMenuAutoComplete: {
    margin: '2px 0px 0px',
    position: 'relative',
    zIndex: 1,
    borderRadius: '4px',
    overflow: 'hidden',
    boxShadow: '0 2px 12px 2px rgba(0, 0, 0, 0.09)',
    '& li': {
      margin: '0',
      padding: '3px',
      height: '40px',
    },
  },
  searchBoxArrow: {
    fontSize: '22px',
    height: '44px',
    display: 'flex',
    marginLeft: '10px',
  },
  searchBoxField: {
    fontSize: '20px',
  },
  toggleSearchBar: {
    lineHeight: 'normal',
  },
})

class SearchBox extends React.Component {
  static propTypes = {
    actions: PropTypes.object.isRequired,
    inMenu: PropTypes.bool, // If true, component is displayed in menu bar
  }

  constructor(props) {
    super(props)
    this.state = {
      address: '',
      searchBtnDisabled: true,
      didSearchUpdate: false,
    }
  }

  componentDidMount() {
    const { location, inMenu, isSearchAsHeader } = this.props
    const query = queryString.parse(location.search)
    if (inMenu || isSearchAsHeader) {
      this.setState({
        address: query.address || '',
      })
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!nextProps.inMenu && !nextProps.isSearchAsHeader) {
      this.setState({
        address: '',
      })
    } else {
      const query = queryString.parse(nextProps.location.search)
      this.setState({
        address: query.address || '',
      })
    }
  }

  handleKeyUp = ev => {
    const { searchBtnDisabled } = this.state

    if (ev.keyCode === 13 && !searchBtnDisabled) {
      this.search(ev)
    }
  }

  handleChange = address => {
    this.setState({ address, searchBtnDisabled: true, didSearchUpdate: true })
  }

  handleSelect = (address, placeID) => {
    // placeID is null when user press Enter Key and doesnt select a value
    if (placeID !== null) {
      this.setState({ address, searchBtnDisabled: false })
    }
  }

  search(ev) {
    const { actions, history, isSearchAsHeader = false, toggleSearchBox } = this.props
    const { address } = this.state
    const {
      homeTypesSelected,
      numberOfBedrooms,
      numberOfBathrooms,
      priceMaximum,
      priceMinimum,
      propertyTypesSelected,
      sortBy,
      sortOrder,
      areaMinimum,
      areaMaximum,
    } = this.props.filters
    const searchString = `address=${address}&propertyType=${propertyTypesSelected.join(',')}&homeType=${homeTypesSelected.join(
      ','
    )}&numberOfBedrooms=${numberOfBedrooms}&numberOfBath=${numberOfBathrooms}&min=${priceMinimum}&max=${priceMaximum}&sortBy=${sortBy}&order=${sortOrder}&minArea=${areaMinimum}&maxArea=${areaMaximum}`
    ev.preventDefault()
    utils.trackEvent({ category: 'Search', action: 'Search for location - ' + address })
    actions.fetchLocation(address).then(() => {
      if (isSearchAsHeader) {
        toggleSearchBox()
      }
      // If the we are under one subdomain page (franchisee/adcouncil) and the user runs a search we will redirect to the property page but using main/base domain
      if (utils.isBaseDomain(window.location.hostname)) {
        history.push({
          pathname: `${types.ROUTES_PATH.PROPERTY}`,
          search: searchString,
        })
      } else {
        //FIXME we can extract this logic to create url somewhere
        window.location = `${window.location.protocol}//${process.env.REACT_APP_BASE_DOMAINS}${window.location.port ? ':' + window.location.port : ''}${
          types.ROUTES_PATH.PROPERTY
        }?${searchString}`
      }
    })
  }

  render() {
    const { classes, inMenu, isSearchAsHeader = false, toggleSearchBox } = this.props
    const { searchBtnDisabled, address } = this.state

    return (
      <Paper className={`${classes.searchBox} ${inMenu ? classes.menuSearchBox : isSearchAsHeader ? classes.searchAsHeader : ''}`}>
        <PlacesAutocomplete value={address} onChange={ev => this.handleChange(ev)} onSelect={(a, p) => this.handleSelect(a, p)}>
          {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
            <div id={'search_bar'} className={classes.toggleSearchBar}>
              <TextField
                className={classes.locationSearchInput}
                {...getInputProps({
                  placeholder: 'Search by City, State or Zip Code',
                  onKeyUp: this.handleKeyUp,
                })}
                InputProps={{
                  disableUnderline: true,
                  style: {
                    display: 'flex',
                    alignItems: 'center',
                    padding: 0,
                  },
                  startAdornment: inMenu ? null : (
                    <div className={classes.container}>
                      {isSearchAsHeader ? (
                        <KeyboardBackspace className={classes.searchBoxArrow} onClick={toggleSearchBox} />
                      ) : (
                        <Hidden xsDown>
                          <InputAdornment
                            position="start"
                            style={{
                              color: '#a9aeba',
                              margin: '0 10px 0 15px',
                            }}>
                            <Search className={classes.searchBoxField} />
                          </InputAdornment>
                        </Hidden>
                      )}
                    </div>
                  ),
                  endAdornment: (
                    <div className={classes.container}>
                      {inMenu ? (
                        <InputAdornment
                          component={Button}
                          position="start"
                          disabled={searchBtnDisabled}
                          className={`${classes.searchBtn} ${classes.headerSearchBtn}`}
                          onClick={ev => this.search(ev)}>
                          <span>
                            {' '}
                            <Search className={classes.searchBoxField} />
                          </span>
                        </InputAdornment>
                      ) : (
                        <Hidden xsDown>
                          <InputAdornment
                            component={Button}
                            position="start"
                            disabled={searchBtnDisabled}
                            className={classes.searchBtn}
                            onClick={ev => {
                              this.search(ev)
                            }}>
                            <span> Search </span>
                          </InputAdornment>
                        </Hidden>
                      )}
                      <Hidden smUp>
                        <InputAdornment
                          component={Button}
                          position="start"
                          disabled={searchBtnDisabled}
                          className={classes.searchBtn}
                          onClick={ev => {
                            this.search(ev)
                          }}>
                          <span>
                            {' '}
                            <Search className={classes.searchBoxField} />
                          </span>
                        </InputAdornment>
                      </Hidden>
                    </div>
                  ),
                }}
              />

              <div className={inMenu || isSearchAsHeader ? classes.inMenuAutoComplete : classes.autocompleteDropdownContainer}>
                {suggestions.map(suggestion => {
                  const className = suggestion.active ? 'suggestion-item--active' : 'suggestion-item'
                  const style = suggestion.active ? { backgroundColor: '#ffffff', cursor: 'pointer' } : { backgroundColor: '#ffffff', cursor: 'pointer' }
                  return (
                    <MenuItem
                      {...getSuggestionItemProps(suggestion, {
                        className,
                        style,
                      })}>
                      <span className={classes.suggestionLi}>{suggestion.description}</span>
                    </MenuItem>
                  )
                })}
              </div>
            </div>
          )}
        </PlacesAutocomplete>
      </Paper>
    )
  }
}

SearchBox.propTypes = {
  classes: PropTypes.object.isRequired,
}

function mapStateToProps(state) {
  return {
    queryAddress: state.properties.get('queryAddress'),
    subdomain: state.subdomain.data,
    filters: state.filters,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
  }
}

const searchBox = connect(
  mapStateToProps,
  mapDispatchToProps
)(SearchBox)
export default withStyles(styles)(withRouter(searchBox))



// WEBPACK FOOTER //
// ./src/components/SearchBox.js